/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Availability_PlaceholderInputs */

const en_candidate_profile_availability_placeholder = /** @type {(inputs: Candidate_Profile_Availability_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Available from August 2024`)
};

const de_candidate_profile_availability_placeholder = /** @type {(inputs: Candidate_Profile_Availability_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Verfügbar ab August 2024`)
};

/**
* | output |
* | --- |
* | "e.g., Available from August 2024" |
*
* @param {Candidate_Profile_Availability_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_availability_placeholder = /** @type {((inputs?: Candidate_Profile_Availability_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Availability_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_availability_placeholder(inputs)
	return en_candidate_profile_availability_placeholder(inputs)
});